import { render, staticRenderFns } from "./ChampionshipSelector.vue?vue&type=template&id=186e5a32&"
import script from "./ChampionshipSelector.vue?vue&type=script&lang=js&"
export * from "./ChampionshipSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports